"use client";

import { StaticImport } from "next/dist/shared/lib/get-img-props";
import TextHeader from "@/components/typography/TextHeader";
import Image from "next/image";
import { ZoomInPartialOnScroll } from "@/components/effects/ZoomInPartialOnScroll";

export default function FullscreenImageHero({
  children,
  image,
  imageDesktop,
}: React.PropsWithChildren<{
  children?: React.ReactNode;
  image: string | StaticImport;
  imageDesktop: string | StaticImport;
}>) {
  return (
    <ZoomInPartialOnScroll className="relative overflow-hidden rounded-lg">
      <Image src={image} alt={""} className="w-full object-cover lg:hidden" />
      <Image
        src={imageDesktop}
        alt={""}
        className="hidden w-full object-cover lg:block"
      />
      {children && (
        <div className="absolute inset-0 flex justify-center px-5 pt-24 lg:items-center lg:pt-0">
          <div className="max-w-screen-md">
            <TextHeader className="text-center text-white">
              {children}
            </TextHeader>
          </div>
        </div>
      )}
    </ZoomInPartialOnScroll>
  );
}
